import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 2rem 2rem;
  align-items: start;
  background-color: ${COLORS.GRAY};
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  padding: 1.5rem 2rem;
  flex-direction: column;
`;
